export default "__VITE_ASSET__27cf224f__"